import { useMemo } from "react"

import { useRoutes } from "react-router-dom"

import { Sidebar, useIsMobileDevice } from "@l2r-front/l2r-ui"

import { SpeedingsSidebar } from "../../containers/SpeedingsSidebar"

export function SpeedingsSidebarRouter() {
    const isMobile = useIsMobileDevice()

    const sidebarRoutes = useMemo(() => ([
        { path: "/", element: <SpeedingsSidebar /> },
        { path: "/:road", element: <SpeedingsSidebar /> },
    ]), [])


    return <Sidebar shadowed={!isMobile}>{useRoutes(sidebarRoutes)}</Sidebar>
}
